import type { ContractorW9Status } from '../types';

export type ContractorW9Evidence = {
  w9Status?: unknown;
  w9StoragePath?: unknown;
};

/** Normalize CRM / admin spellings to the stored enum. */
export function parseContractorW9Status(raw: unknown): ContractorW9Status {
  const s = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
  if (s === 'on_file' || s === 'onfile' || s === 'true' || s === 'yes') return 'on_file';
  if (s === 'expired') return 'expired';
  return 'missing';
}

/**
 * True when a W-9 is already on file.
 * A stored document counts even if `w9Status` was never stamped (or was reset to missing).
 * Explicit `expired` still blocks.
 */
export function isContractorW9OnFile(profile: ContractorW9Evidence | null | undefined): boolean {
  if (!profile) return false;
  const status = parseContractorW9Status(profile.w9Status);
  if (status === 'expired') return false;
  if (status === 'on_file') return true;
  return typeof profile.w9StoragePath === 'string' && profile.w9StoragePath.trim().length > 0;
}

/** Prior successful 1099 filings — used to grandfather contractors who already submitted. */
export function hasContractorPriorFiling(args: {
  timesheetStatuses?: Array<string | undefined>;
  entryStatuses?: Array<string | undefined>;
  invoiceStatuses?: Array<string | undefined>;
}): boolean {
  const filed = (status: string | undefined) => {
    const v = String(status || '').toLowerCase();
    return v === 'submitted' || v === 'invoiced' || v === 'paid' || v === 'pending_payment';
  };
  return (
    (args.timesheetStatuses || []).some(filed)
    || (args.entryStatuses || []).some(filed)
    || (args.invoiceStatuses || []).some(filed)
  );
}
